import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { 
  FiLock, 
  FiEye, 
  FiEyeOff, 
  FiCheckCircle, 
  FiAlertCircle, 
  FiArrowLeft 
} from "react-icons/fi";
import api from "../../services/api";
import "./ResetarSenha.scss"; // Importando o SCSS

const LOGO_URL = "https://res.cloudinary.com/dhy96qtc9/image/upload/v1769419088/uploads_istudo/gyviusvabxpnealiltse.png";

export default function ResetarSenhaInstituicao() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");

  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false); // Controle de visibilidade da senha
  
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [ok, setOk] = useState(false);

  const togglePasswordVisibility = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setErro("");

    if (!token) {
      setErro("Token de recuperação inválido ou ausente.");
      return;
    }

    if (!novaSenha || novaSenha.length < 6) {
      setErro("A senha deve ter pelo menos 6 caracteres.");
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setErro("As senhas não coincidem.");
      return;
    }

    setLoading(true);

    try {
      await api.post("/auth/reset-password", {
        token,
        novaSenha,
      });

      setOk(true);

      // Aguarda 2,5 segundos para o usuário ler a mensagem de sucesso e redireciona
      setTimeout(() => {
        navigate("/", { replace: true });
      }, 2500);

    } catch (err) {
      const msg =
        err?.response?.data?.erro ||
        "Não foi possível redefinir a senha. O link pode estar expirado.";
      setErro(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="reset-password-container">
      <div className="glass-card animate-entrance">
        
        <div className="logo-container">
          <img src={LOGO_URL} alt="Logo Istudo" className="company-logo" />
        </div>

        {ok ? (
          // --- TELA DE SUCESSO ---
          <div className="success-content animate-fade-in">
            <FiCheckCircle className="success-icon" />
            <h2>Senha atualizada!</h2>
            <p>Sua senha foi redefinida com sucesso. Redirecionando você para o login...</p>
          </div>
        ) : (
          // --- FORMULÁRIO ---
          <div className="form-content animate-fade-in">
            <h1>Criar nova senha</h1>
            <p className="subtitle">
              Digite e confirme sua nova senha para acessar sua conta.
            </p>

            <form onSubmit={onSubmit}>
              {/* Campo: Nova Senha */}
              <div className="input-group">
                <label htmlFor="novaSenha">Nova senha</label>
                <div className="input-wrapper">
                  <FiLock className="input-icon-left" />
                  <input
                    id="novaSenha"
                    type={mostrarSenha ? "text" : "password"}
                    placeholder="Mínimo de 6 caracteres"
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    required
                    disabled={loading}
                  />
                  <button 
                    type="button" 
                    className="btn-toggle-password" 
                    onClick={togglePasswordVisibility}
                    tabIndex="-1" // Evita que o Tab pare aqui durante a digitação
                  >
                    {mostrarSenha ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              {/* Campo: Confirmar Senha */}
              <div className={`input-group ${erro ? 'has-error' : ''}`}>
                <label htmlFor="confirmarSenha">Confirmar senha</label>
                <div className="input-wrapper">
                  <FiLock className="input-icon-left" />
                  <input
                    id="confirmarSenha"
                    type={mostrarSenha ? "text" : "password"}
                    placeholder="Repita a nova senha"
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    required
                    disabled={loading}
                  />
                </div>
                {erro && (
                  <span className="error-msg">
                    <FiAlertCircle style={{ marginRight: 4 }} /> {erro}
                  </span>
                )}
              </div>

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? (
                  <span className="loading-state">Salvando alteração...</span>
                ) : (
                  "Redefinir Senha"
                )}
              </button>
            </form>

            <div className="footer-links">
              <Link to="/" className="back-link-simple">
                <FiArrowLeft /> Voltar para o login
              </Link>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}